export default "__VITE_ASSET__9dd9d602__"